module.exports = __webpack_public_path__ + "static/media/keyoperation1.bd18c24f.png";